export default {
  getCompetency: (state) => state.competency,
};
